package com.evoapps.evoshift.domain.usecase.settings

import com.evoapps.evoshift.domain.repository.WorkplaceRepository

class DeleteRecurringCostRuleUseCase(
    private val workplaceRepository: WorkplaceRepository
) {
    suspend operator fun invoke(ownerId: String, ruleId: String): Result<Unit> {
        return workplaceRepository.deleteRecurringCostRule(ownerId, ruleId)
    }
}
